import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { toggleBulletList as toggleBulletListKeymap, toggleOrderedList as toggleOrderedListKeymap, formatShortcut } from '@atlaskit/editor-common/keymaps';
import { listMessages } from '@atlaskit/editor-common/messages';
import { getInputMethodFromParentKeys } from '@atlaskit/editor-common/toolbar';
import { ListBulletedIcon, ListNumberedIcon, ToolbarButton, ToolbarTooltip } from '@atlaskit/editor-toolbar';
export var ListsIndentationHeroButton = function ListsIndentationHeroButton(_ref) {
  var api = _ref.api,
    parents = _ref.parents;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['list'], function (states) {
      var _states$listState, _states$listState2, _states$listState3;
      return {
        bulletListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListActive,
        bulletListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.bulletListDisabled,
        orderedListActive: (_states$listState3 = states.listState) === null || _states$listState3 === void 0 ? void 0 : _states$listState3.orderedListActive
      };
    }),
    bulletListActive = _useSharedPluginState.bulletListActive,
    bulletListDisabled = _useSharedPluginState.bulletListDisabled,
    orderedListActive = _useSharedPluginState.orderedListActive;
  var shortcut = orderedListActive ? formatShortcut(toggleOrderedListKeymap) : formatShortcut(toggleBulletListKeymap);
  var onClick = function onClick() {
    var inputMethod = getInputMethodFromParentKeys(parents);
    if (orderedListActive) {
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.list.commands.toggleOrderedList(inputMethod));
    } else {
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.list.commands.toggleBulletList(inputMethod));
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: orderedListActive ? formatMessage(listMessages.orderedList) : formatMessage(listMessages.bulletedList)
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: orderedListActive ? /*#__PURE__*/React.createElement(ListNumberedIcon, {
      label: formatMessage(listMessages.orderedList),
      size: "small"
    }) : /*#__PURE__*/React.createElement(ListBulletedIcon, {
      label: formatMessage(listMessages.bulletedList),
      size: "small"
    }),
    isSelected: bulletListActive || orderedListActive,
    isDisabled: !orderedListActive && bulletListDisabled,
    ariaKeyshortcuts: shortcut,
    onClick: onClick
  }));
};